import React from "react";

import Loading from "common/fragments/Loading";
import NonIdealState from "common/fragments/NonIdealState";
import QueryComponent from "core/api/QueryComponent";
import { FragmentProvider } from "core/components/FragmentProvider";
import { IPanelProps, Panel } from "core/decorators/Panel";
import StringUtil from "core/util/StringUtil";
import ProgramListConfig from "./config/ProgramListConfig";
import Program from "./entities/Program";
import * as programDisplay from "./fragments/program/displayFragments";
import labelProvider from "./Program.labels";

const { Labels } = labelProvider;

const ProgramDisplay = FragmentProvider.forFragments("program:display", programDisplay);



// WEBPACK FOOTER //
// ./src/panels/program/ProgramList.panel.tsx